// @ts-nocheck

import React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ReactComponent as ChartIcon } from '../../assets/svg/chartbar.svg';
import { Target } from '../../client';

export const PlayerWidgetButtonSvgClassName = 'player-widget-button-svg';
const SvgChart = styled(ChartIcon)`
  padding-top: 0.4em;
  color: ${({ theme }) => theme.common.colors.mild};
  &&&& {
    width: 1.3em;
    height: 1.3em;
  }
  cursor: pointer;
  ${Target.__MOBILE__
    ? undefined
    : css`
        &:hover {
          color: ${({ theme }) => theme.common.colors.light};
        }
      `}
`;

export type Props = {
  playerSrId: number;
  playerTeam: 1 | 2;
  matchId: number;
};

const PlayerWidgetButton = ({ playerSrId, playerTeam, matchId }: Props) => (
  <NavLink
    to={{
      hash: '#playerStats',
      state: {
        playerWidgetProps: {
          matchId,
          playerTeam,
          playerSrId,
        },
      },
    }}
  >
    <SvgChart className={PlayerWidgetButtonSvgClassName} />
  </NavLink>
);

export default PlayerWidgetButton;
